export const DATE_SEARCH_PARAM_FORMAT = 'dd.MM.yyyy';
